import { $baseSrv, $openSrv, $userSrv } from '@/plugin/axios'

function loadUserInfo () {
  return $userSrv.get('/main/profile/info', {})
}

function projectPlugins (projectId) {
  let data = { projectId }
  return $userSrv.get('/main/profile/projectPlugins', data)
}

function personalProjectPlugins (projectId) {
  let data = { projectId }
  return $userSrv.get('/main/profile/personalProjectPlugins', data)
}

function hostConfig () {
  let url = '/main/public/config'
  let data = {
    host: location.host
  }
  return $openSrv.get(url, data)
}

function projectUserHospitals (projectId) {
  return $baseSrv.get('/main/project/user/hospital/all', { projectId })
}

export default {
  loadUserInfo: loadUserInfo,
  projectPlugins: projectPlugins,
  personalProjectPlugins: personalProjectPlugins,
  hostConfig: hostConfig,
  projectUserHospitals: projectUserHospitals
}
